import { request } from './client';

export const apiGetBlogPosts = () => request('/blog');

export const apiGetBlogPost = (slug) => request(`/blog/${slug}`);

export const apiGetRelatedBlogPosts = (slug, limit = 3) =>
  request(`/blog/${slug}/related?limit=${limit}`);
